// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__AWWdm","active":"MainNavigation_active__LZzaI","list":"MainNavigation_list__F38-1"};